import { createSlice, current } from '@reduxjs/toolkit';
import {
	getFlowRateUnitList,
	getFlowRateUnit,
	addNewFlowRateUnit,
	updateFlowRateUnit,
	deleteFlowRateUnit,
	checkFlowRateUnitExists,
} from './thunk';

export const initialState = {
	itemFlowRateUnitList: [],
	itemFlowRateUnit: null,
	isFlowRateUnitLoading: false,
	isFlowRateUnitSuccess: false,
	dataFlowRateUnit: null,
	statementList: [],
	statementListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	registerDisabled: false,
	requireReloadSelectionItemsGrid: false,
	exists: false,
};

const FlowRateUnitSlice = createSlice({
	name: 'FlowRateUnit',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getFlowRateUnitList.pending, state => {
			state.isLoadingList = true;
			state.isFlowRateUnitSuccess = false;
		});

		builder.addCase(getFlowRateUnitList.fulfilled, (state, action) => {
			let statementList = action.payload;
			let statementListSelect = [];

			action.payload.map(item =>
				statementListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.itemFlowRateUnitList = statementList;
			state.statementList = statementList;
			state.statementListSelect = statementListSelect;
			state.isLoadingList = false;
			state.isFlowRateUnitSuccess = true;
		});

		builder.addCase(getFlowRateUnitList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isFlowRateUnitSuccess = false;
		});

		builder.addCase(getFlowRateUnit.pending, state => {
			state.isFlowRateUnitLoading = true;
			state.isFlowRateUnitSuccess = false;
		});

		builder.addCase(getFlowRateUnit.fulfilled, (state, action) => {
			state.itemFlowRateUnit = action.payload;
			state.isFlowRateUnitLoading = false;
			state.isFlowRateUnitSuccess = true;
		});

		builder.addCase(getFlowRateUnit.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isFlowRateUnitLoading = false;
			state.isFlowRateUnitSuccess = false;
		});

		builder.addCase(addNewFlowRateUnit.pending, state => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});

		builder.addCase(addNewFlowRateUnit.fulfilled, (state, action) => {
			state.itemFlowRateUnitList.push(action.payload);
			state.statementList.push(action.payload);
			state.statementListSelect.push({
				item: action.payload,
				value: action.payload._id,
				label: action.payload.name,
			});
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.requireCloseModal = true;
		});

		builder.addCase(addNewFlowRateUnit.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAddError = true;
		});

		builder.addCase(updateFlowRateUnit.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});

		builder.addCase(updateFlowRateUnit.fulfilled, (state, action) => {
			state.itemFlowRateUnitList = state.itemFlowRateUnitList.map(
				flowRateUnitList =>
					flowRateUnitList._id.toString() === action.payload._id.toString()
						? { ...flowRateUnitList, ...action.payload }
						: flowRateUnitList
			);
			state.statementList = state.statementList.map(flowRateUnitList =>
				flowRateUnitList._id.toString() === action.payload._id.toString()
					? { ...flowRateUnitList, ...action.payload }
					: flowRateUnitList
			);
			state.statementListSelect = state.statementListSelect.map(item =>
				item.value.toString() === action.payload._id.toString()
					? {
							item: action.payload,
							value: action.payload._id,
							label: action.payload.name,
					  }
					: item
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.requireCloseModal = true;
		});

		builder.addCase(updateFlowRateUnit.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteFlowRateUnit.pending, state => {
			state.isLoadingList = true;
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});

		builder.addCase(deleteFlowRateUnit.fulfilled, (state, action) => {
			state.itemFlowRateUnitList = state.itemFlowRateUnitList.filter(
				flowRateUnitList =>
					flowRateUnitList._id.toString() !== action.payload._id.toString()
			);
			state.statementList = state.statementList.filter(
				flowRateUnitList =>
					flowRateUnitList._id.toString() !== action.payload._id.toString()
			);
			state.statementListSelect = state.statementListSelect.filter(
				item => item.value.toString() !== action.payload._id.toString()
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.requireCloseModal = true;
		});

		builder.addCase(deleteFlowRateUnit.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleteError = true;
		});

		builder.addCase(checkFlowRateUnitExists.pending, state => {
			state.exists = false;
		});

		builder.addCase(checkFlowRateUnitExists.fulfilled, (state, action) => {
			state.exists = action.payload.exists;
		});

		builder.addCase(checkFlowRateUnitExists.rejected, (state, action) => {
			state.exists = false;
		});
	},
});

export const { setRequireCloseModal } = FlowRateUnitSlice.actions;

export default FlowRateUnitSlice.reducer;
